module.exports = __webpack_public_path__ + "img/1462183148.67e47257.jpg";